  <template>
  <div>
    <v-dialog
      scrollable
      v-model="dialog"
      max-width="500px"
      :retain-focus="false"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-bind:valid="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-text-field
                  v-model="editedItem.categoryName"
                  :label="$t('_issues.category')"
                  readonly
                  filled
                ></v-text-field>
              </v-row>
              <v-row>
                <v-textarea
                  v-model="editedItem.issueDescription"
                  :label="$t('_issues.issueDescription')"
                  readonly
                  filled
                  rows="3"
                ></v-textarea>
              </v-row>
              <v-row>
                <v-select
                  v-model="editedItem.status"
                  :label="$t('_issues.status')"
                  :items="options"
                  item-value="value"
                >
                  <template v-slot:item="data">
                    {{ $t(data.item.i18nKey) }}
                  </template>
                  <template v-slot:selection="data">
                    {{ $t(data.item.i18nKey) }}
                  </template>
                </v-select>
              </v-row>
              <v-row>
                <v-textarea
                  auto-grow
                  clearable
                  clear-icon="mdi-close-circle"
                  v-model="editedItem.operatorReply"
                  :label="$t('_issues.operatorReply')"
                  rows="3"
                ></v-textarea>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="send" v-bind:valid="valid">
            {{ $t("common.send") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    editedItem: Object,
    editedIndex: Number,
    issueCategories: Array,
    neighborhoods: Array,
    incidentTypes: Array,
    routeName: String,
    categoryId: String,
  },
  data() {
    return {
      mapDialog: false,
      locSelected: [{ lat: null, lon: null }],
      valid: false,
      disabled: false,
      dialogDelete: false,
      defaultItem: {
        title: "",
        text: "",
        date: "",
      },
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: null,
      y: null,
      mode: null,
      timeout: 3000,
      nameRules: [(v) => !!v || "Ad Girilmelidir"],
      incidentRules: [(v) => !!v || "Olay Tipi Seçilmelidir"],
      countyRules: [(v) => !!v || "İlçe Seçilmelidir"],
      neighborhoodRules: [(v) => !!v || "Mahalle Seçilmelidir"],
      startTimeRules: [(v) => !!v || "Başlangıç Zamanı Girilmelidir"],
      endTimeRules: [(v) => !!v || "Bitiş Zamanı Girilmelidir"],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu1: false,
      menu2: false,
      start: null,
      end: null,
      statusEnums: [],
    };
  },
  created() {
    this.statusEnums = $enums.issueStatus;
  },
  computed: {
    formTitle() {
      return this.$t("common.reply");
    },
    options() {
      return Object.values(this.$enums.issueStatus);
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    changeNeigh(county) {},
    close() {
      this.dialog = false;
      this.$emit("cancelled");

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async send() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        //Object.assign(this.counties[this.editedIndex], this.editedItem);
        try {
          await this.$store.dispatch("issues/replyIssue", {
            issueId: this.editedItem.id,
            operatorReply: this.editedItem.operatorReply,
            status: this.editedItem.status, //this.editedItem.status,
          });
          this.editedItem.issueId = "";
          this.editedItem.operatorReply = "";
          this.editedItem.status = "";
          this.snackbar = true;
          this.snackColor = "success";
          this.snackText = "Yanıt Gönderildi!";
          this.x = "center";
          this.y = "bottom";
        } catch (e) {
          this.snackbar = true;
          this.snackColor = "error";
          this.snackText = "Yanıt Gönderilemedi!";
          console.log(e);
          this.x = "center";
          this.y = "bottom";
        }
      }
      this.$emit("confirmed", this.editedItem);
      this.close();
    },
  },
};
</script>